// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IExistsUserEstimationScoreFactRequest,
  TExistsUserEstimationScoreFactModel,
  IMappers,
  TExistsUserEstimationScoreFactResponse,
  IExistsUserEstimationScoreFactResponse,
  IExistsUserEstimationScoreFactResponseError,
} from './types';

export const defaultConfig: TExistsUserEstimationScoreFactModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/exists-user-estimation-score-fact/',
  requestType: 'json',
} as TExistsUserEstimationScoreFactModel;

export function createExistsUserEstimationScoreFactModel(
  parameters: IExistsUserEstimationScoreFactRequest,
): TExistsUserEstimationScoreFactModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IExistsUserEstimationScoreFactOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IExistsUserEstimationScoreFactRequest;
}

export async function fetchExistsUserEstimationScoreFact<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IExistsUserEstimationScoreFactOptions<TResponse200, TResponse400>): Promise<
  TExistsUserEstimationScoreFactResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createExistsUserEstimationScoreFactModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IExistsUserEstimationScoreFactResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IExistsUserEstimationScoreFactResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TExistsUserEstimationScoreFactResponse;
}
